<template>
  <footer class="app-footer">
    <div class="container">
      <div class="row">
        <div class="footer-nav">
          <div class="footer-nav-contact">
            <p>{{$t("footer.company")}}</p>
            <p>{{$t("footer.contact")}}</p>
            <p>{{$t("footer.phone")}}</p>
            <p>{{$t("footer.email")}}</p>
            <p>{{$t("footer.address")}}</p>
          </div>
          <img class="footer-nav-logo" src="../assets/qrcode_for_gh_55f843d0e539_258.jpg" />
        </div>
      </div>
    </div>
    <p class="footer-icp">{{$t("footer.icp")}}<a class="icp" target="_blank" href="http://beian.miit.gov.cn">粤ICP备2021076852号</a></p>
  </footer>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: #2F2E33;
}

.footer-nav {
  height: 218px;
  display: flex;
  align-items: center;
  position: relative;

  .footer-nav-logo {
    height: 124px;
    width: 124px;
    margin-left: 20px;
    flex: 0 0 auto;
  }

  .footer-nav-contact {
    height: 124px;
    color: #EEE;
    width: 0;
    flex: 1 1 auto;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: var(--font-normal-size);
  }
}
.icp {
  color: inherit;
  text-decoration: none;
  &:hover {
    color: #DDD;
  }
}

.footer-icp {
  // position: absolute;
  // left: 50%;
  // bottom: 12px;
  // transform: translateX(-50%);
  font-size: 12px;
  color: #BBB;
  line-height: 40px;
  text-align: center;
  background-color: #111;
}
@media screen and (max-width: 500px) {
  .footer-nav {
  }
}
</style>